import { useState, useEffect } from 'react';
import st from './index.module.css';
import classNames from 'classnames';

const Timer = () => {
  const targetDate = new Date('2026-06-11T23:59:59').getTime();

  const getTimeLeft = () => {
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const format = num => String(num).padStart(2, '0');

  return (
    <div className="bg-[#000000] overflow-hidden py-[48px] text-white">
      <div className="container">
        <div className="flex flex-col items-center gap-[36px]">
          <div className="flex flex-col items-center gap-[18px] relative">
            <p className="text-[18px] font-thin">Tournament starts in</p>
            <h2 className="md:text-[48px] text-[32px] font-medium md:leading-[59px] leading-[40px]">World Cup Kick-off</h2>
            <p className="text-[18px] text-white font-thin text-center">
              <span className="text-[#9EBF91] font-bolder">Book before May 31 </span> to secure placements
            </p>
          </div>
          <div className="flex flex-row justify-center items-center md:gap-[32px] gap-[12px] text-[#EDEEB2]">
            <div className="flex flex-col gap-[12px] items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[110px] leading-[56px]">{format(timeLeft.days)}</span>
                <span className="md:text-[73px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">days</span>
            </div>
            <div className="flex flex-col gap-[12px]  items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[110px] leading-[56px]">{format(timeLeft.hours)}</span>
                <span className="md:text-[73px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">hours</span>
            </div>
            <div className="flex flex-col gap-[12px] items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[110px] leading-[56px]">{format(timeLeft.minutes)}</span>
                <span className="md:text-[73px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">minutes</span>
            </div>
            <div className="flex flex-col gap-[12px] items-center">
              <span className="md:text-[96px] text-[38px] font-[600] md:leading-[110px] leading-[56px]">{format(timeLeft.seconds)}</span>
              <span className="md:text-[24px] text-[10px]  font-extralight">seconds</span>
            </div>
          </div>
          <p className="md:text-[18px] text-[16px] text-white font-thin mt-[24px] text-center leading-[22px]">
            Packages sold on a first-come basis.
            <span className="text-[#9EBF91] font-bolder"> Dominance package includes priority premium inventory.</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Timer;
